import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appSelectOnFocus]',
  standalone: true
})
export class SelectOnFocusDirective {
  public constructor() { }

  @HostListener('focus', ['$event'])
  onFocus(event: FocusEvent): void {
    const inputElement = event.target as HTMLInputElement;
    if (inputElement && typeof inputElement.select === 'function') {
      inputElement.select();
    }
  }

}
